import { dataAlignLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAlignLeft = /*#__PURE__*/createIcon(dataAlignLeft)
export default IconAlignLeft
